import { environment } from '@quartz-iam-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .factory('employeeProfileService', service);

    service.$inject = ['$http', '$q'];

    function service($http, $q) {
        var baseUrl = environment.apiUrl + '/ID/Employee/API/';

        var service = {
            getEmployeeBusinessTasks                    : getEmployeeBusinessTasks,
            getEmployeeBusinessTaskSystemRoles          : getEmployeeBusinessTaskSystemRoles,
            getEmployeeAuthorizedBusinessTasks          : getEmployeeAuthorizedBusinessTasks,
            getActiveAuthorizedSystemAndRoles           : getActiveAuthorizedSystemAndRoles,
            getDefaultEntitlementSysRoles               : getDefaultEntitlementSysRoles,
            getAllAccessRequests                        : getAllAccessRequests,
            getAllSystemRolePending                     : getAllSystemRolePending,
            getEventsForEmployee                        : getEventsForEmployee,
            getSystemOwned                              : getSystemOwned,
            addBackupSystemOwner                        : addBackupSystemOwner,
            changePrimarySystemOwner                    : changePrimarySystemOwner,
            removeBackupSystemOwner                     : removeBackupSystemOwner,
            getPasswordResetInfos                       : getPasswordResetInfos,
            checkAccessCardNumber                       : checkAccessCardNumber,
            confirmPasswordReset                        : confirmPasswordReset,
            getEmployeeXrefLocations                    : getEmployeeXrefLocations,
            getEmployeeWithLocations                    : getEmployeeWithLocations,
            updateEmployeeLocations                     : updateEmployeeLocations,
            getDepartureInfos                           : getDepartureInfos,
            cancelDeparture                             : cancelDeparture,
            getPendingEmployeeInfos                     : getPendingEmployeeInfos,
            changePendingEmployee                       : changePendingEmployee,
        };
        return service;

        ////////////

        function getEmployeeBusinessTasks(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/BusinessTasks';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getEmployeeBusinessTaskSystemRoles(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/BusinessTaskSystemRoles';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getEmployeeAuthorizedBusinessTasks(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/AuthorizedBusinessTasks';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getActiveAuthorizedSystemAndRoles(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/AuthorizedSystemAndRoles';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getDefaultEntitlementSysRoles(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/DefaultEntitlementSysRole';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getAllAccessRequests(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/AccessRequests';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getAllSystemRolePending(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/PendingSystemRoles';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getEventsForEmployee(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/Events';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function getSystemOwned(resParams, requestConfig) {
            var resUrl = baseUrl + resParams.EmployeeID + '/SystemOwned';
            var defaultConfig = {};

            return $http
                .get(resUrl, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function addBackupSystemOwner(resParams, data, requestConfig) {
            var resUrl = baseUrl + 'Systems/' + resParams.SystemID + '/SystemOwner/Backup/' + resParams.BackupEmployeeID;
            var defaultConfig = {};

            return $http
                .post(resUrl, data, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function changePrimarySystemOwner(resParams, data, requestConfig) {
            var resUrl = baseUrl + 'Systems/' + resParams.SystemID + '/SystemOwner/Primary/' + resParams.NewPrimaryEmployeeID;
            var defaultConfig = {};

            return $http
                .post(resUrl, data, _.assign(defaultConfig, requestConfig))
                .then(function (response) {
                    return response.data;
                });
        }

        function removeBackupSystemOwner(resParams, requestConfig) {
            var resUrl = baseUrl + 'Systems/' + resParams.SystemID + '/SystemOwner/Backup/' + resParams.BackupEmployeeID;
            var defaultConfig = {};

            return $http.delete(resUrl, _.assign(defaultConfig, requestConfig));
        }

        /* Password Reset */
        function getPasswordResetInfos(employeeId) {
            var resUrl = baseUrl + employeeId + '/PasswordReset';

            return $http.get(resUrl)
                        .then(function (response) {
                            return response.data;
                        });
        }

        function checkAccessCardNumber(employeeId, accessCardNb) {
            var resUrl = baseUrl + employeeId + '/PasswordReset/Check';

            return $http.post(resUrl, { AccessCardNb: accessCardNb })
                        .then(function (response) {
                            return response.data;
                        });
        }

        function confirmPasswordReset(employeeId, system) {
            var reqSystemId = system.SystemID || system.PasswordResetAdditionalSystemID;
            var reqIsAdditional = system.IsAdditional;

            var reqUrl = baseUrl + employeeId + '/PasswordReset/Confirm/';
            if (reqIsAdditional) {
                reqUrl += 'AdditionalSystem/';
            }
            reqUrl += reqSystemId;

            return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        }

        /* Locations */
        function getEmployeeWithLocations(employeeId) {
            var resUrl = baseUrl + employeeId + '/WithLocations';

            return $http.get(resUrl)
                        .then(function (response) {
                            return response.data;
                        });
        }
        function updateEmployeeLocations(employeeWithLocations) {
            var resUrl = baseUrl + employeeWithLocations.EmployeeID + '/Location';

            return $http.post(resUrl, employeeWithLocations)
                        .then(function (response) {
                            return response.data;
                        });
        }

        /* Lookups */
        function getEmployeeXrefLocations() {
            return $http.get(baseUrl + '/Location', { cache: true })
                        .then(function (response) { return response.data; })
        }

        /* Departure */
        function getDepartureInfos(employeeId) {
            var reqUrl = baseUrl + employeeId + '/Departure/Infos';

            return $http
                    .get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
        }
        function cancelDeparture(employeeId) {
            var reqUrl = baseUrl + employeeId + '/Departure/Cancel';

            return $http
                    .post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
        }

        /* Pending Employee */
        function getPendingEmployeeInfos(employeeId) {
            var reqUrl = baseUrl + employeeId + '/Pending/WhenChanging';

            return $http
                    .get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
        }
        function changePendingEmployee(empPendingInfos) {
            var reqUrl = baseUrl + empPendingInfos.EmployeeID + '/Pending/Changing';

            return $http
                    .post(reqUrl, empPendingInfos)
                    .then(function (response) {
                        return response.data;
                    });
        }
    }
})();
